import React from 'react';
import { TableHead } from 'material-ui/Table';
import { withStyles } from 'material-ui/styles';
import TableRow from './headerCells/TableRow';
import styles from './headerCells/headerStyle';


const GridHeader = ({ children, classes}) => {
    return (
        <TableHead className={classes.headerHeight}>
            <TableRow>
                {children}
            </TableRow>
        </TableHead>
    );
};

export default withStyles(styles)(GridHeader, TableRow);